import { forwardRef, type SVGProps } from "react";

interface HouseHeartProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
  strokeWidth?: number | string;
  absoluteStrokeWidth?: boolean;
}

/**
 * HouseHeart - własna ikona w stylu lucide-react (dom z serduszkiem w środku).
 * Lucide 0.462 nie zawiera HouseHeart, więc odtwarzamy ją lokalnie.
 */
export const HouseHeart = forwardRef<SVGSVGElement, HouseHeartProps>(
  (
    {
      size = 24,
      strokeWidth = 2,
      absoluteStrokeWidth,
      color = "currentColor",
      ...props
    },
    ref,
  ) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={
        absoluteStrokeWidth && typeof size === "number"
          ? (Number(strokeWidth) * 24) / size
          : strokeWidth
      }
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* dach + ściany domu (na bazie lucide Home) */}
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5" />
      {/* serduszko w środku domu */}
      <path d="M12 17.5s-3-1.7-3-4a1.8 1.8 0 0 1 3-1.3 1.8 1.8 0 0 1 3 1.3c0 2.3-3 4-3 4Z" />
    </svg>
  ),
);

HouseHeart.displayName = "HouseHeart";
